"use strict";

exports.__esModule = true;
exports.ScatterPlotChart = void 0;
var _react = _interopRequireDefault(require("react"));
var _excluded = ["width", "height", "series", "xScale", "yScale", "color", "radius"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ScatterPlotChart = exports.ScatterPlotChart = function ScatterPlotChart(props) {
  var width = props.width,
    height = props.height,
    series = props.series,
    xScale = props.xScale,
    yScale = props.yScale,
    color = props.color,
    radius = props.radius,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var getXValue = series.getXValue,
    getYValue = series.getYValue,
    data = series.data;
  var xPosition = function xPosition(x) {
    return xScale(x);
  };
  var points = data.map(function (item) {
    var value = getYValue && getYValue(item) || item.value;
    var key = getXValue && getXValue(item) || item.key || "";
    var x = xPosition(key);
    var topY = function topY(value) {
      return yScale(value);
    };
    return /*#__PURE__*/_react["default"].createElement("circle", {
      className: "scatter-plot-point",
      "data-xvalue": key,
      key: x,
      cx: x,
      cy: topY(value) - radius,
      r: radius,
      fill: color || item.color || "blue"
    });
  });
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "data-testid": "scatter-plot-chart",
    width: width,
    height: height
  }, extra), points);
};